const actionTypeIdentifier = 'C64FB0A8-ACD1-4B61-AEBE-BD62E859607A';

export const getGlCodeStatusDropdown = `GET-GL-CODE-STATUS-DROPDOWN-${actionTypeIdentifier}`;
export const getGlCodeDetailsForm = `GET-GL-CODE-DETAILS-FORM-${actionTypeIdentifier}`


export const glCodeDetailsFormModel = {
    glCodeId: 0,
    glCode: null,
    glCodeName: null,
    description: null,
    status: null,
    validFromDate: "",
    validToDate: ""
}